var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg73Collapse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03142a;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.26,11.65l-2.35,2.35,.84,.79c.38,.38,.11,1.04-.43,1.04h-2.84c-.34,0-.61-.27-.61-.61v-2.84c0-.54,.66-.81,1.04-.43l.79,.84,2.35-2.35c.16-.16,.42-.16,.57,0l.64,.64c.16,.16,.16,.42,0,.57Zm-11.14,8.7l2.35-2.35-.84-.79c-.38-.38-.11-1.04,.43-1.04h2.84c.34,0,.61,.27,.61,.61v2.84c0,.54-.66,.81-1.04,.43l-.79-.84-2.35,2.35c-.16,.16-.42,.16-.57,0l-.64-.64c-.16-.16-.16-.42,0-.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg73Collapse);
export default __webpack_public_path__ + "static/media/73-collapse.943dc915dd00e347431b50fc3f61a01d.svg";
export { ForwardRef as ReactComponent };